class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
        let sec_iem = this.closest('cart-remove-button').dataset.index2;

      if(sec_iem != '' && sec_iem != undefined){
                
          let updates = {
            id: sec_iem,
            quantity: 0
          };

          fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(updates)
          })
          .then(response => {
            return response.json(); 
          
          })
            .then(state => {
                let sec_iem1 = this.closest('cart-remove-button').dataset.index;
           
          let update = {
                    id: sec_iem1,
                    quantity: 0
                  };
        
                  fetch(window.Shopify.routes.root + 'cart/change.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(update)
                  })
                  .then(response => {
                    
                    return response.json(); 
                     
                  })
                 .then((state) => {
                   window.location.reload();
                 })
                  .catch((error) => {
                    console.error('Error:', error);
                  });
            })
          .catch((error) => {
            console.error('Error:', error);
          });
   
        
  
      }
        else{
      cartItems.updateQuantity(this.dataset.index, 0);
        }
     
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
       this.disableLoading();
        setting_product_group();
        
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
       this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }
 
  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
        
    jQuery.getJSON('/cart.js', function(cart) { 
      
         var pricen= cart.total_price;
       
        console.log('nes', theme );
        theme.Currency = (function() {
          var moneyFormat = "${{amount}}"; // eslint-disable-line camelcase
      
          function formatMoney(cents, format) {
              if (typeof cents === "string") {
                  cents = cents.replace(".", "");
              }
              var value = "";
              var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
              var formatString = format || moneyFormat;
      
              function formatWithDelimiters(number, precision, thousands, decimal) {
                  thousands = thousands || ",";
                  decimal = decimal || ".";
      
                  if (isNaN(number) || number === null) {
                      return 0;
                  }
      
                  number = (number / 100.0).toFixed(precision);
      
                  var parts = number.split(".");
                  var dollarsAmount = parts[0].replace(
                      /(\d)(?=(\d\d\d)+(?!\d))/g,
                      "$1" + thousands 
                  );
                  var centsAmount = parts[1] ? decimal + parts[1] : "";
      
                  return dollarsAmount + centsAmount;
              }
      
              switch (formatString.match(placeholderRegex)[1]) {
                  case "amount":
                      value = formatWithDelimiters(cents, 2);
                      break;
                  case "amount_no_decimals":
                      value = formatWithDelimiters(cents, 0);
                      break;
                  case "amount_with_comma_separator":
                      value = formatWithDelimiters(cents, 2, ".", ",");
                      break;
                  case "amount_no_decimals_with_comma_separator":
                      value = formatWithDelimiters(cents, 0, ".", ",");
                      break;
                  case "amount_no_decimals_with_space_separator":
                      value = formatWithDelimiters(cents, 0, " ");
                      break;
                  case "amount_with_apostrophe_separator":
                      value = formatWithDelimiters(cents, 2, "'");
                      break;
              }
              return formatString.replace(placeholderRegex, value);
          }
      
          return {
              formatMoney: formatMoney,
          };
      })();
        var Shopify = Shopify || {};
        Shopify.money_format = "${{amount}}";

      
  Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);
  
    function defaultOption(opt, def) {
       return (typeof opt == 'undefined' ? def : opt);
    }
  
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');
  
      if (isNaN(number) || number == null) { return 0; }
  
      number = (number/100.0).toFixed(precision);
  
      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';
  
      return dollars + cents;
    }
  
    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
  
    return formatString.replace(placeholderRegex, value);
  };
        var totalprice =  theme.Currency.formatMoney(
        cart.total_price,
        theme.moneyFormat
        );
         console.log(totalprice);
      $('.totals__subtotal-value').text(totalprice); 
      setting_product_group();
      
})
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  });
};


document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener('click', function(event) {
    
    const etarget = event.target;

    if (etarget.closest(".cart-item-setting-remove")) {
      const cartItem = etarget.closest(".cart-item-setting-remove");
      const id1 = cartItem.getAttribute("data-index");
      const id2 = cartItem.getAttribute("data-index2");

      // Remove first item, then second, then reload
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ id: id1, quantity: 0 })
      })
      .then(response => response.json())
      .then(() => {
        if (id2) {
          return fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ id: id2, quantity: 0 })
          }).then(response => response.json());
        }
      })
      .then(() => {
        window.location.reload();
      })
      .catch(error => {
        console.error('Error removing items:', error);
      });
    }
  });
});


function update_cart_count(){
  fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(cart => {
      const count = cart.item_count;
    
      const cartCountDiv = document.querySelector('.cart-count');
      if (cartCountDiv) {
        const spans = cartCountDiv.querySelectorAll('span');
    
        if (spans.length >= 2) {
          spans[0].textContent = count;
          spans[1].textContent = `${count} item${count !== 1 ? 's' : ''}`;
        }
      }else{
        const cartIcon = document.querySelector('.cart_icon');
        cartIcon.innerHTML = cartIcon.innerHTML + `
        <div class="cart-count">
          <span aria-hidden="true">${count}</span>
          <span class="visually-hidden">${count} item${count !== 1 ? 's' : ''}</span>
        </div>`;
        
      }
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });

}

 function setting_product_group(){
        let elements = document.querySelectorAll('[data-setting-id]');
        
        let groupedElements = {};
        let groupedElementsIds = {};
        
        elements.forEach(element => {
            const settingId = element.getAttribute('data-setting-id');
            const varId = element.getAttribute('data-item-id');
            
            if (!groupedElements[settingId]) {
                groupedElements[settingId] = "";
            }   
          if (!groupedElementsIds[settingId]) {
                groupedElementsIds[settingId] = [];
            }        
          groupedElementsIds[settingId].push(varId);
           
          
            
          
            groupedElements[settingId] += element.innerHTML;
        });
        var title = ` <div class="cart-item-setting-title">Setting Product</div>`
       const itemsRowsContainer = document.querySelector('.cd-items-rows');

        Object.entries(groupedElements).forEach(([settingId, content]) => {
            const newRowTr = document.createElement('tr');
            newRowTr.classList.add('cd-row'); // Add a class to the row
            newRowTr.classList.add('cart-item'); // Add a class to the row
            newRowTr.classList.add('cart-item-setting'); // Add a class to the row
         
            newRowTr.setAttribute('role', 'row');
            var rButtonIds = "";
            groupedElementsIds[settingId].forEach(value => {
              if(rButtonIds == ""){
                rButtonIds += `data-index="${value}"`;
              }else{
                rButtonIds += ` data-index2="${value}" `;
                
              }
            });
          var rButton = `<buttom ${rButtonIds} class="cart-item-setting-remove">
                       <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation" class="icon icon-remove">
                <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
              </svg>
              
            </button>`
          
            newRowTr.innerHTML = title + content + rButton // Use innerHTML to keep HTML structure

            itemsRowsContainer.appendChild(newRowTr);
            update_cart_count()
        });
    }
